import { DCRecord } from "@/@types/lib/dataController";
import api from "../lib/api";
import { IApiResponse } from "@/@types/lib/api/api";

export interface IObjektiService {
  getObjekti: (lokacijaId: number) => Promise<any>;
  partiallyUpdateObjekt: (recordId: number, data: any) => Promise<any>;
  changeQcState: (recordId: number, newState: boolean) => Promise<IApiResponse>
}

function getObjekti(lokacijaId: number) {
  const apiInstance = new api();
  const url = "komunalne-obveze/" + lokacijaId.toString() + "/objekti-geom";

  return apiInstance.Call(url, "get");
}

function partiallyUpdateObjekt(recordId: number, data: any) {
  const apiInstance = new api();
  const url = `operations/objekti/${recordId}`;

  return apiInstance.Call(url, "patch", data);
}

const changeQcState = (recordId: number, newState: boolean) => {
  const apiInstance = new api();
  const url = `qc/objekti/${recordId}/qc-check/`
  const body = {
    qc_check: newState
  }
  return apiInstance.Call(url, "patch", body);
}

const objektiService: IObjektiService = {
  getObjekti,
  partiallyUpdateObjekt,
  changeQcState
};


export default objektiService;